import { render } from "./VoiceClone.vue?vue&type=template&id=11ea5fdb&scoped=true"
import script from "./VoiceClone.vue?vue&type=script&lang=js"
export * from "./VoiceClone.vue?vue&type=script&lang=js"

import "./VoiceClone.vue?vue&type=style&index=0&id=11ea5fdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ea5fdb"]])

export default __exports__